    <span>Picking : Chris</span>
    <span class='spacer'></span>
    <span>Up Next : Bradley</span>